import React, { useEffect, useState } from "react";

// Material
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { Button, Tab, Tabs, Typography } from "@mui/material";

// Components
import Modal from "../../../../components/modal/index";
import Spinner from "../../../../components/spinner";

import Iibb from "./iibb";
import ExemptionIibb from "./exemptionIibb";

// Hooks
import useStyles from "../styles";
import useNotify from "../../../../hooks/notify";
import useCustomer from "../../../../hooks/customers/useCustomer";

// Models
import { IibbCategories } from "../../../../models/IibbCategories";

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div 
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
};

const TaxConfigModal = ({ customer, modalProps }) => {
  const { classes } = useStyles();
  const [tabSelected, setTabSelected] = useState(0);
  const { loading, replaceTaxConfig } = useCustomer(customer?.id);
  const { Notify, variants } = useNotify();

  const [{ iibb, exemptions, convenios }, setTaxConfiguration] = useState({
    iibb: {
      iibb: customer?.documentNumber,
      category: -1
    },
    convenios: [],
    exemptions: []
  })

  useEffect(() => {
    if(customer?.taxConfig) {
      const { iibb, exemptions, convenios  } = customer.taxConfig;

      setTaxConfiguration({
        iibb: {
          ...iibb,
          iibb: iibb?.iibb || customer.documentNumber
        },
        convenios: convenios ?? [],
        exemptions: exemptions ?? []
      })
    }
  }, [customer?.taxConfig, customer?.documentNumber]);
  
  const handleTabChange = (event, value) => {
    setTabSelected(value);
  };

  const handleChangeTaxConfig = (name, value) => {
    setTaxConfiguration(state => ({ ...state, [name]: value }))
  }

  const save = () => {
    if (iibb?.category === IibbCategories.Exento && exemptions.length === 0) {
      Notify("Se requiere de una exencion cargada", variants.ERROR);
      return;
    }

    if (iibb?.iibb <= 0) {
      Notify(`Debe ingresar un número de Ingresos brutos.`, variants.ERROR);
      return;
    }

    exemptions.forEach((e) => {
      if (typeof e.id === "string" && e.id.startsWith("temp")) e.id = 0;
    });

    replaceTaxConfig({
      customerId: customer.id,
      iibb: {
        ...iibb,
        category: iibb?.category > 0 
          ? iibb.category
          : null,
      },
      convenios,
      exemptions
    });

    modalProps.onClose();
  };

  return (
    <>
      { loading && <Spinner lockScreen message="Buscando configuración" /> }
      <Modal {...modalProps}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Paper variant="outlined">
              <Tabs value={tabSelected} onChange={handleTabChange}>
                <Tab label="IIBB"></Tab>
                <Tab label="Exenciones IIBB"></Tab>
              </Tabs>
            </Paper>
          </Grid>
          <Grid size={12}>
            <Paper className={classes.paper} variant="outlined">
              <Grid
                container
                size={{
                  xs: 12,
                  md: 12
                }}
              >
                <Grid
                  container
                  size={{
                    xs: 12,
                    md: 12
                  }}
                >
                  <Typography variant="inherit">
                    Cada tratamiento impositivo provincial asociado a clientes,
                    proveedores y sucursales tiene asociado una Categoría de
                    percepción de Ingresos Brutos.
                  </Typography>
                </Grid>
                <Grid
                  container
                  size={{
                    xs: 12,
                    md: 12
                  }}
                >
                  <Typography variant="inherit">
                    Esto permite administrar diferentes categorías para los
                    diferentes agentes de percepción.
                  </Typography>
                </Grid>
                <Grid
                  container
                  size={{
                    xs: 12,
                    md: 12
                  }}
                >
                  <Typography variant="inherit">
                    Las categorías se indican con un número de 1 a 5. En esta tabla
                    se pueden ingresar los porcentajes de percepción asociados a
                    cada categoría. El sistema trabaja con cinco categorías, si hay
                    algunas que no se utilizan, pueden dejarse con porcentaje 0.
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid size={12}>
            <TabPanel value={tabSelected} index={0}>
              <Iibb 
                iibb={iibb} 
                handleChange={(payload) => handleChangeTaxConfig('iibb', payload)}
              />
            </TabPanel>

            <TabPanel value={tabSelected} index={1}>
              <ExemptionIibb
                exemptions={exemptions}
                handleChange={(payload) => handleChangeTaxConfig('exemptions', payload)} 
              />
            </TabPanel>
          </Grid>

          <Grid container justifyContent="center" size={12}>
            <Button onClick={save} variant="contained" color="primary" name="taxConfigAcceptButton">
              Aceptar configuración
            </Button>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};

export default TaxConfigModal;
